<template>
    <div class="header-slider-wrapper" v-bind:style=imageUrl>
        <div class="header-slider">
            <h1 class="header-slider--title" v-html="slides[activeSlide].title" :class="{dark: slides[activeSlide].theme, 'conceal': slides[activeSlide].theme && mobile}">
              <!-- The <br>
              Supplier <br>
              You can rely on -->
            </h1>
            
            <a :href="slides[activeSlide].link" class="btn btn-arrow header-slider--btn" :class="{'btn-white': !slides[activeSlide].theme}">
              Go to catalog
              <svg class="svg-sprite-icon svg-sprite-unstyled icon-arrow-right-long">
                <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-arrow-right-long"></use>
              </svg>
            </a>
            <ul class="header-slider-list">
                <li class="header-slider-list--item" :class="{dark: slides[activeSlide].theme, 'conceal': slides[activeSlide].theme && mobile}">
                * Available Only for Aesthetic Professionals
                </li>
            </ul>
            <ul class="header-slider-nav">
                <template v-for="(item, index) in slides">
                    <li class="header-slider-nav--item" :class="{'active': index == activeSlide}" v-bind:key="index" @click="ChangeSlide(index)">
                        <span class="header-slider-nav--link"></span>
                    </li>
                </template>
                <!-- <li class="header-slider-nav--item">
                    <span class="header-slider-nav--link"></span>
                </li>
                <li class="header-slider-nav--item">
                    <span class="header-slider-nav--link"></span>
                </li>
                <li class="header-slider-nav--item active">
                    <span class="header-slider-nav--link"></span>
                </li>
                <li class="header-slider-nav--item">
                    <span class="header-slider-nav--link"></span>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            slides: Array
            // categoryUrl: {
            //     type: String,
            //     required: false
            // },
        },
        data: () => ({
            count: 0,
            activeSlide: 0,
            mobile: false
            // slides: [
            //     {
            //         title: 'Botulinum',
            //         link: '#',
            //         image: '/img/carousel/1.jpg',
            //         active: true,
            //     },
            //     {
            //         title: 'Dermal Fillers',
            //         link: '#',
            //         image: '/img/carousel/2.jpg',
            //         active: false,
            //     },
            //     {
            //         title: 'Mesotherapy',
            //         link: '#',
            //         image: '/img/carousel/3.jpg',
            //         active: false,
            //     },
            //     {
            //         title: 'Lipolitics',
            //         link: '#',
            //         image: '/img/carousel/4.jpg',
            //         active: false,
            //     },
            // ],
        }),

        methods: {
            slidesCount() {
                this.count = this.slides.length;
            },
            ChangeSlide(index) {
                this.activeSlide = index
            },
            resize() {
                this.mobile =  window.innerWidth < 1101 ? true : false;
            },
        },
        computed: {
            imageUrl: function() {
                if(this.mobile) {
                    return {'background-image': `url(${this.slides[this.activeSlide].image_mobile})`}    
                }
                return {'background-image': `url(${this.slides[this.activeSlide].image})`}
            }
        },

        mounted() {
            // console.log('Component mounted.')
            this.slidesCount();
            this.resize();
            window.addEventListener('resize', this.resize)
        }
    }
</script>

<style scope>
    .dark {
        color: #000
    }
    .conceal {
        opacity: 0;
    }
</style>
